import React from 'react'
import styled from 'styled-components'

import StatCard from './StatCard'

import { IEvaluationResultAverages } from '../../hooks/useEvaluationStatistics'
import { IconType } from '../icon/IconType'

interface IProps {
  current: IEvaluationResultAverages
  previous?: IEvaluationResultAverages
  compareActive?: boolean
}

interface IMetricRow {
  key: 'goals' | 'skills' | 'culture'
  icon: IconType
  titleKey: string
  currentValue?: number
  previousValue?: number
  measured: number
  total: number
  // Goals are shown as a percentage achieved; skills & culture as a score out
  // of 100. The suffix anchors goals, the "/ 100" scale anchors the others.
  suffix?: string
  showScale?: boolean
}

const KPIStrip: React.FC<IProps> = ({ current, previous, compareActive }) => {
  const metrics: IMetricRow[] = [
    {
      key: 'goals',
      icon: 'Goals',
      titleKey: 'general.goals.goalRealisation',
      currentValue: current.avgGoalAchievement,
      previousValue: previous?.avgGoalAchievement,
      measured: current.measuredGoalMembers,
      total: current.totalGoalMembers,
      suffix: '%',
    },
    {
      key: 'skills',
      icon: 'Skills',
      titleKey: 'general.skills',
      currentValue: current.avgSkill,
      previousValue: previous?.avgSkill,
      measured: current.measuredSkillMembers,
      total: current.totalSkillMembers,
      showScale: true,
    },
    {
      key: 'culture',
      icon: 'Culture',
      titleKey: 'general.feedback.culture',
      currentValue: current.avgCulture,
      previousValue: previous?.avgCulture,
      measured: current.measuredCultureMembers,
      total: current.totalCultureMembers,
      showScale: true,
    },
  ]

  return (
    <Strip>
      {metrics.map((m) => (
        <StatCard
          key={m.key}
          icon={m.icon}
          titleKey={m.titleKey}
          value={m.currentValue}
          suffix={m.suffix}
          showScale={m.showScale}
          current={m.currentValue}
          previous={m.previousValue}
          compareActive={compareActive}
          measured={m.measured}
          total={m.total}
        />
      ))}
    </Strip>
  )
}

export default KPIStrip

const Strip = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`
